<template>
  <div class="tab-navigation">
    <TabButton
      v-for="tab in tabs"
      :key="tab.id"
      :label="tab.label"
      :icon-src="tab.iconSrc"
      :icon-alt="tab.iconAlt"
      :is-active="activeTab === tab.id"
      @click="handleTabClick(tab.id)"
    />
  </div>
</template>

<script lang="ts">
import Vue from "vue";
import TabButton from "@/components/atoms/TabButton.vue";
import closeIcon from "@/assets/icons/close-icon.svg";
import assistIcon from "@/assets/icons/assist-icon.svg";
import historyIcon from "@/assets/icons/history-icon.svg";

interface Tab {
  id: string;
  label: string;
  iconSrc: string;
  iconAlt: string;
}

export default Vue.extend({
  name: "TabNavigation",
  components: {
    TabButton,
  },
  props: {
    activeTab: {
      type: String,
      default: "assist",
    },
  },
  data() {
    return {
      tabs: [
        {
          id: "close",
          label: "閉じる",
          iconSrc: closeIcon,
          iconAlt: "閉じるアイコン",
        },
        {
          id: "assist",
          label: "アシスト依頼",
          iconSrc: assistIcon,
          iconAlt: "肉球アイコン",
        },
        {
          id: "history",
          label: "過去ログ",
          iconSrc: historyIcon,
          iconAlt: "証明書アイコン",
        },
      ] as Tab[],
    };
  },
  methods: {
    handleTabClick(tabId: string): void {
      this.$emit("tab-change", tabId);
    },
  },
});
</script>

<style lang="scss" scoped>
.tab-navigation {
  display: flex;
  width: 100%;
  background-color: var(--color-background-normal);
  border-bottom: 1px solid var(--color-border);
}

.tab-navigation :deep(.tab-button) {
  flex: 1;
  min-width: 0;
}

/* レスポンシブ対応 */
@media (max-width: 576px) {
  .tab-navigation {
    /* モバイル時の調整があれば追加 */
  }
}
</style>
